import { render, staticRenderFns } from "./AssignmentIntroduce.vue?vue&type=template&id=74f07ace&scoped=true&"
import script from "./AssignmentIntroduce.vue?vue&type=script&lang=js&"
export * from "./AssignmentIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentIntroduce.vue?vue&type=style&index=0&id=74f07ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f07ace",
  null
  
)

export default component.exports